import { formatVerbatimMoneyCurrency } from '@shared/utils/formatMoneyDisplay';
import { NOT_RECORDED_LABEL } from '../../../../utils/fundStatementLabels';

export type FigureColumn = 'Gross' | 'VAT' | 'Net';

interface Props {
    column: FigureColumn;
    value: string | null;
    currency: string;
}

export function FigureCell({ column, value, currency }: Props) {
    return (
        <dd className="text-right tabular-nums">
            <span className="sr-only">{column}, </span>
            {value === null ? (
                <>
                    <span aria-hidden="true">{'–'}</span>
                    <span className="sr-only">{NOT_RECORDED_LABEL}</span>
                </>
            ) : (
                formatVerbatimMoneyCurrency(value, currency)
            )}
        </dd>
    );
}
